<template lang="pug">
    v-text-field.date-field( 
        :hide-details="hideDetails"
        :outline="outline"
        :flat='flat'
        ref="field" 
        readonly 
        :rules='rules'
        single-line
        :solo="solo"
        v-bind="fieldProps" 
        v-model="formatted" 
    )
        template( slot="append" )
            v-tooltip( bottom )
                template( slot="activator" )
                    v-btn( :color="isReadonly ? 'default' : 'primary'" icon flat @click="modal = true" )
                        v-icon today
                span {{ this.isReadonly ? "Ver calendario" : "Seleccionar fecha" }}
        slot( name="prepend" slot="prepend" )
            v-dialog( v-model="modal" :width="290" )
                v-date-picker( locale="es" v-bind="pickerProps" v-model="date" )        
        slot( name="prepend-inner" slot="prepend-inner" )
</template>

<script>
    export default {
        name: "date-field",
        computed: {

            /**
             * 
             */
            isMonthly() {
                return this.pickerProps.type === 'month'
            },

            /**
             * 
             */
            isReadonly() {
                return this.pickerProps.readonly
            },
        },
        data () {
            return {
                date: "",
                formatted: "",
                modal: false,
            }
        },
        props: {

            /**
             * 
             */
            fieldProps: {
                type: Object,
                default: () => ({})
            },

            /**
             * 
             */
            hideDetails: Boolean,            
            
            /**
             * 
             */
            pickerProps: {
                type: Object,
                default: () => ({})
            }, 
            
            /**
             *
             */
            outline: Boolean,
            solo: Boolean,
            flat: Boolean,

            /**
             *
             */
            rules: {
                type: Array,
                default: () => [],
            },

            /**
             * 
             */
            value: String,
        },
        methods: {

            /**
             * 
             */
            format ( data ) {

                //
                const date  = new Date( this.isMonthly ? data + '-15' : data )
                    , year  = date.getUTCFullYear()
                    , month = date.getUTCMonth() + 1 < 10 ? "0" + ( date.getUTCMonth() + 1 ) : date.getUTCMonth() + 1
                    , day   = date.getUTCDate() < 10 ? "0" + date.getUTCDate() : date.getUTCDate()

                //
                const hasReturn = isNaN(year) || isNaN( month ) || isNaN( day )

                //
                return hasReturn ? '' : this.isMonthly ? [ month, year ].join( "-" ) : [ day, month, year ].join( "-" )
            },

            /**
             * 
             */
            reset () {
                this.date = this.value || "";
            },

            /**
             * { function_description }
             *
             * @param      {<type>}  days    The days
             */
            sumDays(days) {

                //
                var date  = new Date( this.isMonthly ? this.date + '-15' : this.date )

                //
                date.setDate(date.getUTCDate() + days)

                console.log(date, days)

                //
                const year  = date.getUTCFullYear()
                    , month = date.getUTCMonth() + 1 < 10 ? "0" + ( date.getUTCMonth() + 1 ) : date.getUTCMonth() + 1
                    , day   = date.getUTCDate() < 10 ? "0" + date.getUTCDate() : date.getUTCDate()

                //
                const hasReturn = isNaN(year) || isNaN( month ) || isNaN( day )

                //
                this.formatted = hasReturn ? '' : this.isMonthly ? [ month, year ].join( "-" ) : [ day, month, year ].join( "-" )
            },
        },
        mounted () {
            this.reset()
        },
        watch: {

            /**
             * 
             */
            date () {
                this.formatted = this.format( this.date );
            },

            /**
             * 
             */
            formatted () {
                if ( !this.pickerProps.readonly ) this.$emit( 'input', this.date )
            },

            /**
             * 
             */
            value () {
                this.reset()
            }
        },
    }
</script>

<style>
    .date-field .v-input__prepend-outer {
        margin: 0;
    }
    .date-field.v-text-field--outline .v-btn.v-btn--flat.v-btn--icon {
        margin-top: -8px;
    }
    .date-field.v-text-field--solo .v-btn.v-btn--flat.v-btn--icon {
        margin-bottom: 6px;
    }
</style>
